import { ReactNode } from "react"

type State = {
    showOverlay: boolean
    content: ReactNode
    header: ReactNode
    isVideo: boolean
    disableOnClickOutside: boolean
    error: unknown
    overlay: ReactNode | null
    disableClose: boolean
    zIndex?: number
}

export type OverlayOptions = {
    header?: ReactNode
    isVideo?: boolean
    disableOnClickOutside?: boolean
    overlay?: ReactNode | null
    disableClose?: boolean
    zIndex?: number
}

export type Action =
    | { type: "OPEN_OVERLAY"; payload: OverlayOptions & { content: ReactNode } }
    | { type: "CLOSE_OVERLAY" }
    | { type: "UPDATE_HEADER"; payload: { header: ReactNode } }
    | { type: "ERROR"; error?: unknown }

const initialState: State = {
    showOverlay: false,
    content: null,
    header: null,
    isVideo: false,
    disableOnClickOutside: false,
    error: null,
    overlay: null,
    disableClose: false,
    zIndex: undefined,
}

const OverlayReducer = (state: State, action: Action): State => {
    switch (action.type) {
        case "OPEN_OVERLAY":
            return {
                ...state,
                showOverlay: !action.payload.overlay,
                content: action.payload.content,
                header: action.payload.header,
                isVideo: !!action.payload.isVideo,
                disableOnClickOutside: !!action.payload.disableOnClickOutside,
                overlay: action.payload.overlay || null,
                disableClose: !!action.payload.disableClose,
                zIndex: action.payload.zIndex,
            }
        case "CLOSE_OVERLAY":
            return {
                ...state,
                showOverlay: false,
                content: null,
                header: null,
                overlay: null,
                disableClose: false,
                zIndex: undefined,
            }
        case "UPDATE_HEADER":
            return {
                ...state,
                header: action.payload.header,
            }
        case "ERROR":
            return {
                ...state,
                error: action.error,
            }

        default:
            throw new Error(`Unhandled action type: ${(action as Action).type}`)
    }
}

export { OverlayReducer, initialState }
